import { Lightning } from '@lightningjs/sdk';
import FocusShader from '../../../../shaders/focus.shader';

export class ButtonBackground extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      shader: {
        type: FocusShader,
      },
    };
  }

  get scale() {
    return super.scale;
  }

  set scale(value) {
    super.scale = value;
    this.shader.scale = value;
  }

  get borderColor() {
    return this.shader.strokeColor;
  }

  set borderColor(value) {
    this.shader.strokeColor = value;
  }

  get innerColor() {
    return this.shader.innerColor;
  }

  set innerColor(value) {
    this.shader.innerColor = value;
  }

  get borderWidth() {
    return this.shader.outline;
  }

  set borderWidth(value) {
    this.shader.outline = value;
  }

  get borderRadius() {
    return this.shader.radius;
  }

  set borderRadius(value) {
    this.shader.radius = value;
  }
}
